import {
    Card,
    Descriptions,
    Avatar
} from "antd";
import {useEffect} from "react";

export default function DealSummaryCard({
                                            conversation,
                                            product
                                        }) {

    // const {
    //     product
    // } = product;

    return (

        <Card>

            <Descriptions
                column={1}
            >

                <Descriptions.Item
                    label="Produit"
                >
                    {product?.productName}
                </Descriptions.Item>

                <Descriptions.Item
                    label="Quantité"
                >
                    {
                        product?.sellingQuantity
                    }

                    {" "}

                    {
                        product?.measurementUnit
                    }
                </Descriptions.Item>

                <Descriptions.Item
                    label="Prix"
                >
                    {
                        product?.sellingPrice
                    }

                    {" "}

                    {
                        product?.currency
                    }
                </Descriptions.Item>

            </Descriptions>

        </Card>
    );
}